import { required } from "vuelidate/lib/validators";
import moment from 'moment' 
const StrIyilestirme = {
  data() {
    return {
      StrIyilestirmeData: {
        Donemid: null,
        Gelistirme: null,
        Birimids: null,
        Iyilestirme: null,
        Bitistarihi: null,
        Durum: 1,
        Turid: null,
        Amacdonemid: null,
        Amacid: null
      },
      FormDataType: {
        Turid: { FieldName: "Turid", Field: "combobox", FieldTitle: "Tür", ComboDataArray: [] },
        Donemid: { FieldName: "Donemid", Field: "combobox", FieldTitle: "Dönem", ComboDataArray: [] },
        Gelistirme: { FieldName: "Gelistirme", Field: "textarea", FieldTitle: "Gelişmeye Açık Yön", FieldType: "text" },
        Birimids: { FieldName: "Birimids", Field: "combobox", FieldTitle: "Birim", ComboDataArray: [] },
        Iyilestirme: { FieldName: "Iyilestirme", Field: "textarea", FieldTitle: "Planlanan İyileştirme" },
        Bitistarihi: { FieldName: "Bitistarihi", Field: "date", FieldTitle: "Bitiş Tarihi" },
        Iyilestirmetarih: { FieldName: "Iyilestirmetarih", Field: "date", FieldTitle: "Cevap Gönderim Son Tarihi" }, 
        
          Amacdonemid:{FieldName:"Amacdonemid",Field:"combobox",FieldTitle:"Amaç Dönemi",ComboDataArray:[]},
          Amacid:{FieldName:"Amacid",Field:"combobox",FieldTitle:"Amaç",ComboDataArray:[]},

        Durum: { FieldName: "Durum", Field: "combobox", FieldTitle: "Durum", ComboDataArray: [
          { Id: 1, Value: "İyiştirme Oluşturuldu"},{ Id: 2, Value: "Birimlere Gönderildi"},{ Id: 3, Value: "İyileştirme Tamamlandı"},
        ] },
      },
      DurumEnum: {
        1: "İyiştirme Oluşturuldu",
        2: "Birimlere Gönderildi",
        3: "İyileştirme Tamamlandı",
      }
    }
  },
  validations: {
    FormData: {
      Turid: { required },
      Donemid: { required },
      Gelistirme: { required },
      Iyilestirme: {  },
      Bitistarihi: {  },
      IslemTarihi: {},
      Iyilestirmetarih: {},
      Amacdonemid: {},
      Amacid: {},
    },
    Filter:{ 
      Turid: {},
      Birimid: {},
      Donemid: {},
      Durum: {},
      Amacdonemid: {},
      Amacid: {},
    }
  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999"
    }
    this.ActionsGet({ "Service": "OBirim", "Page": Page }).then((res) => {

      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Birimids.ComboDataArray.push({ Id: res.Data[i].Id, Value: res.Data[i].BirimAdi })
      }
    });
    let Tarih = moment(new Date()).format('YYYY-MM-DD');
    this.ActionsFilterGet({ "Service": "StrPerfDonem", "Page": Page, Filter: "&Tipkod=8&BasTarihi=" + Tarih + "&BitTarihi=" + Tarih }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {

        this.FormDataType.Donemid.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Aciklama,
        });

      }
    });

    
    this.ActionsFilterGet({ "Service": "StrIyilestirmeTur", "Page": Page, Filter: "" }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {

        this.FormDataType.Turid.ComboDataArray.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Tur,
        });

      }
    });
    this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: "" }).then((res) => {
            for (var i = 0; i < res.Data.length; i++) {
          
                    this.FormDataType.Amacdonemid.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Aciklama})
              
            }
          })
  }, 
}
export default StrIyilestirme